import React, { FC } from 'react';
import { observer } from 'mobx-react-lite';
import { Box, Button, Typography } from '@material-ui/core';
import { RetailGreenCheckbox, RetailPhoneFormat, RetailTextField } from "components/retail/structures";
import commonStores from 'stores/common';
import { ProgressSpinner } from 'components/common/atoms';
import { ServerError } from 'components/common/structures';
import { basicFormStyles } from 'containers/common/form/ScheduleForm';
import useI18n from "evcharging/hooks/useI18n";

const NewContactUsForm: FC = observer(() => {
  const { t } = useI18n();

  const {
    newContactUsFormStore: {
      onChange,
      onSubmit,
      getForm,
      getErrors,
      data,
      getErrorMessage,
      closeError,
      disableConfirm,
    },
  } = commonStores;
  const classes = basicFormStyles();
  const values = getForm;
  const errors = getErrors;

  return (
    <Box className={classes.card}>
      <Typography className={classes.label}>
        {t('form.label.fullName')} <strong>*</strong>
      </Typography>
      <RetailTextField
        type={'text'}
        id={'full-name'}
        placeholder={t('form.label.fullName-placeholder')}
        onChange={onChange('fullName')}
        value={values.fullName}
        error={!!errors.fullName}
        helperText={errors.fullName}
        newEnergy5
      />
      <Typography className={classes.label}>
        {t('form.label.workEmail')} <strong>*</strong>
      </Typography>
      <RetailTextField
        type={'email'}
        id={'email'}
        placeholder={'name@mail.com'}
        onChange={onChange('email')}
        value={values.email}
        error={!!errors.email}
        helperText={errors.email}
        newEnergy5
      />
      <Typography className={classes.label}>
        {t('form.label.phone')} <strong>*</strong>
      </Typography>
      <RetailTextField
        type="text"
        id={'phone'}
        placeholder={'___-___ - ____'}
        onChange={onChange('phone')}
        InputProps={{ inputComponent: RetailPhoneFormat }}
        value={values.phone}
        error={!!errors.phone}
        helperText={errors.phone}
        newEnergy5
      />
      <Typography className={classes.label}>{t('form.label.message')}</Typography>
      <RetailTextField
        multiline
        maxCount={500}
        type={'text'}
        id={'your-message'}
        placeholder={t('form.label.message-placeholder')}
        onChange={onChange('message')}
        value={values.message}
        newEnergy5
      />
      <RetailGreenCheckbox
        label={t('form.label.agree-receive')}
        onChange={(event) => {
          onChange('agreeToReceive')(event.target.checked ? 'yes' : 'no');
        }}
        checked={values.agreeToReceive === 'yes'}
      />
      {data.isLoading ? (
        <ProgressSpinner className={classes.submit} />
      ) : (
        <Button
          onClick={onSubmit}
          className={classes.submit}
          id={'button-contactUs'}
          variant={'contained'}
          fullWidth
          color={'primary'}
          aria-label="Submit"
        >
          {t('action.submit')}
        </Button>
      )}
      <ServerError
        onClose={disableConfirm}
        reverseColor
        newStyle
        message={!data.isConfirm && t('contact-us.request-submitted')}
      />
      <ServerError onClose={closeError} message={getErrorMessage} />
    </Box>
  );
});

export default NewContactUsForm;
